import config from "./config";
var axios = config();

export default {
  getCommunityPartner(id) {
    return axios.get("/api/CommunityPartners/" + id);
  },

  // Feb. 25, 2022, Marina:
  getCommunityPartnerTranslationalTeams(communityPartnerId) {
    return axios.get("/api/CommunityPartners/" + communityPartnerId + "/teams");
  },

  // March 2, 2022, Marina:
  getAwardTranslationalTeams(awardId) {
    return axios.get("/api/awards/" + awardId + "/teams");
  },

  // March 2, 2022, Marina:
  getProposalTranslationalTeams(proposalId)
  {
    return axios.get("/api/proposals/" + proposalId + "/teams");
  },

  // March 2, 2022, Marina:
  getProjectTranslationalTeams(projectId)
  {
    return axios.get("/api/projects/" + projectId + "/teams");
  }
};
